import { Utility } from "src/helpers/utility";

/**
 * Brands that ship a translation overlay (currently en-US only).
 *
 * For these, the effective i18n language becomes `<locale>-<brandId>` (e.g.
 * `en-US-bridgeu`), which is registered in src/i18n.js as a SPARSE overlay that
 * falls back to the base language. Brands not listed here (or non-en locales)
 * use the plain base language.
 *
 * The default brand (cialfo) has no overlay — it IS the base copy.
 */
const BRANDS_WITH_OVERLAY = ["bridgeu"];

const OVERLAY_BASE_LOCALE = "en-US";

/**
 * Compose the effective i18n language for a locale + the active brand.
 *
 * @param {string} locale  the base language from Redux (e.g. "en-US", "zh-CN").
 * @returns {string} the language to pass to i18n.changeLanguage.
 */
export function getBrandLanguage(locale) {
  const brandId = Utility.getBrandId();

  if (
    locale === OVERLAY_BASE_LOCALE &&
    BRANDS_WITH_OVERLAY.includes(brandId)
  ) {
    return `${locale}-${brandId}`;
  }

  return locale;
}

export { BRANDS_WITH_OVERLAY, OVERLAY_BASE_LOCALE };
